// V1
export const quickdraw = {
    colors: ['black', 'blue', 'brown', 'pink', 'purple', 'red', 'teal'],
    photos: {
        'box': [
            'box1.webp',
            'box2.webp',
            'box3.webp',
            'box4.webp'
        ],
        'material': [
            'closed1.webp',
            'closed2.webp',
            'open1.webp',
            'open2.webp'
        ]
    }
}